import { supabase } from "../lib/supabase";
import { SupabaseUser } from "../types/supabase";
import { BaseApi } from "./baseApi";

class UserApi extends BaseApi<SupabaseUser> {
  async getById(id: string): Promise<SupabaseUser | null> {
    const { data, error } = await supabase
      .from("vincer_base_user")
      .select(
        `
        uuid,
        name,
        email,
        date_joined,
        user_roles:user_roles (
          role_name
        )
      `
      )
      .eq("uuid", id)
      .maybeSingle();
    if (error) throw error;
    if (!data) return null;

    // Map user_roles to roles array
    const roles = Array.isArray(data.user_roles)
      ? data.user_roles.map((r: { role_name: string }) => r.role_name)
      : [];

    return {
      uuid: data.uuid,
      name: data.name,
      email: data.email,
      dateJoined: data.date_joined,
      isAdmin: roles.includes("ADMIN"),
      roles,
    };
  }
}

export const userApi = new UserApi("vincer_base_user");
